// extracted by mini-css-extract-plugin
export default {"tagbar":"tagbar___37WLX"};